export const homeObjOne = {
  id: "about",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "who i am",
  headline: "About Me",
  firstParagraph:
    "I am a Software Engineer with 4.5 years of professional experience, specialising in Frontend Development. I focus on building scalable, high-performance, and user-centric web applications with strong attention to design quality and engineering best practices. I have worked with major automotive brands including Hyundai Australia and Genesis Australia, delivering large-scale digital experiences — from interactive 3D car landing pages and accessories pages for Hyundai, to three eCommerce platforms for Genesis luxury vehicles.",
  secondParagraph:
    "Beyond feature development, I have contributed to frontend tooling, design systems, performance optimisation, and accessibility improvements to ensure consistent, fast, and inclusive user experiences across platforms. I am passionate about solving complex frontend challenges, improving code quality, and continuously evolving as an engineer.",
  imgStart: false,
  img: require("../../images/me.JPG").default,
  alt: "Me",
  dark: false,
  primary: true,
  darkText: true,
};
